import { useApolloClient } from '@apollo/client';
import DataTable from '@mostrans/web-components/components/advanced/DataTable';
import Button from '@mostrans/web-components/components/base/Button';
import FormGroup from '@mostrans/web-components/components/base/FormGroup';
import Input from '@mostrans/web-components/components/base/Input';
import { useConfirmationModal } from '@mostrans/web-components/hooks/useConfirmationModal';
import { Grid, Link, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { updateStatusMediaLandingPage } from '../../../../GQL/mutations';
import Title from '../../../../components/Layout/Title';
import { titleAtoms } from '../../../../shared/atoms/titleAtoms';
import { globalLoadingAtom } from '../../../../shared/globalStates';
import { toastError, toastSuccess } from '../../../../shared/helpers';
import { useGetLandingPageAdmin } from '../../../../shared/hooks/useGetMasterData';
import ModalCreateInformation from './ModalCreateInformation';

function Information() {
    const [landingPageAdmin, fetchLandingPageAdmin] = useGetLandingPageAdmin()
    const setTitle = useSetRecoilState(titleAtoms);
    const [showModalCreate, setShowModalCreate] = useState(false);
    const [hideModal, setHideModal] = useState(false);
    const [deskripsiValue, setDeskripsiValue] = useState("")
    const { showConfirmationModal } = useConfirmationModal();
    const client = useApolloClient()
    const setIsLoading = useSetRecoilState(globalLoadingAtom)
    const [dataInformation, setDataInformtion] = useState()


    useEffect(() => {
        setTitle("Information");
    }, []);

    useEffect(() => {
        fetchLandingPageAdmin()
    }, [hideModal])


    const filterInformation = () => {
        const filteredInformation = landingPageAdmin.filter((data) => {
            return (
                data.deskripsi
                    .toLowerCase()
                    .match(deskripsiValue?.toLowerCase())
            );
        });
        return filteredInformation;
    };

    const updateStatusInformation = async (value) => {
        const paramUpdate = {
            id: value.id,
            is_open: value.is_open === true ? false : true
        }
        const show = await showConfirmationModal({
            contentText: "Are you sure to update status?",
        });
        if (show.isConfirmed) {
            try {
                setIsLoading(true)
                const responUpdate = await updateStatusMediaLandingPage(client, paramUpdate);
                fetchLandingPageAdmin()
                if (responUpdate.errMsg === "OK") {
                    toastSuccess("Status Updated")
                    setIsLoading(false)
                } else {
                    toastError(responUpdate.data.deleteMasterClinic.errMsg)
                }
            } catch (error) {
                toastError(error);
            } finally {
                setIsLoading(false)
            }
        }
    };



    const column = [
        {
            getCellKey: (data) => <p key={data.id}>{data?.deskripsi}</p>,
            selector: "deskripsi",
            header: "Description",
            sortBy: "deskripsi",
            sortable: true,
        },
        {
            renderCell: (data) => {
                return data.link_media ?
                    <Link href={data?.link_media}
                        underline="hover"
                        target='_blank'
                    >
                        View Attachment
                    </Link>
                    : <p>No Data.</p>
            },
            selector: "link_media",
            header: "URl Media",
            sortBy: "link_media",
            sortable: true,
        },
        {
            renderCell: (data) => {
                return data.is_open === true ?
                    <p>Active</p>
                    : <p style={{ color: "red" }}>Inactive</p>
            },
            selector: "is_open",
            header: "Status",
            sortBy: "is_open",
            sortable: true,
        },
        {
            selector: "created_date",
            header: "Created Date",
            sortBy: "created_date",
            sortable: true,
        },
        {
            renderCell: (data) => (
                <div key={data.id}>
                    <Button onClick={() => handleModalOpen(data)}>
                        Detail
                    </Button>
                    <Button color={data?.is_open === true ? "error" : "warning"}
                        onClick={() => updateStatusInformation(data)}>
                        {
                            data?.is_open === true ? "Deactivate" : "Activate"
                        }
                    </Button>
                </div>
            ),
            selector: "id",
            header: "Action",
        },
    ]

    const handleModalOpen = async (data) => {
        if (showModalCreate === true) {
            setHideModal(false)
            await setDataInformtion(data)
        } else {
            setShowModalCreate(true)
            await setDataInformtion(data)
        }
    }

    return (
        <React.Fragment>
            {showModalCreate && (
                <ModalCreateInformation
                    open={!hideModal}
                    onClose={() => { setHideModal(true); setDataInformtion() }}
                    dataDetail={dataInformation} />
            )}
            <Paper sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
            }}>
                <Title>Information</Title>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={8} md={8} lg={8} xl={8}>
                        <FormGroup>
                            <Input placeholder="Search Desc Information" onChange={(e) => setDeskripsiValue(e.target.value)} />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} xl={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            onClick={() => {
                                if (showModalCreate) {
                                    setHideModal(false)
                                } else {
                                    setShowModalCreate(true)
                                }
                            }}
                            variant='contained'>
                            Add New Information
                        </Button>
                    </Grid>
                </Grid>
                <DataTable
                    data={filterInformation()}
                    columns={column}
                    hasPagination={true}
                    headerRowStyle={() => ({ fontSize: 13 })}
                    conditionalRowStyle={() => ({ fontSize: 13 })}
                />
            </Paper>
        </React.Fragment>
    )
}

export default Information  